var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShoppingCartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.75L5.47486 3.52897C6.0743 3.79725 6.50384 4.34273 6.62405 4.98838L7.99391 12.3454M7.99391 12.3454L11.4709 31.0194C11.6473 31.9665 12.4738 32.6533 13.4372 32.6533H38.5928C39.5014 32.6533 40.2958 32.0408 40.527 31.1622L44.8176 14.8543C45.1513 13.5862 44.1948 12.3454 42.8835 12.3454L7.99391 12.3454Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0661 38.2517C15.0661 40.9504 12.8784 43.1381 10.1797 43.1381C7.48101 43.1381 5.29328 40.9504 5.29328 38.2517C5.29328 35.553 7.48101 33.3652 10.1797 33.3652C12.8784 33.3652 15.0661 35.553 15.0661 38.2517Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2505 38.7556C45.2505 41.4543 43.0627 43.642 40.364 43.642C37.6653 43.642 35.4776 41.4543 35.4776 38.7556C35.4776 36.0569 37.6653 33.8691 40.364 33.8691C43.0627 33.8691 45.2505 36.0569 45.2505 38.7556Z",
    stroke: "white",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingCartLine);
export default __webpack_public_path__ + "static/media/icon-shopping-cart-line.0049e9666f6d036279d060a616a3ace8.svg";
export { ForwardRef as ReactComponent };